import { useState } from "react";
import Translator from "../translates/Translator";
import { NavLink } from "react-router-dom";

// If path exists then nav is clickable link itself
const NavDropdown = ({ label = "NavMenu", path = null, children }) => {
    const t = Translator();
    const [open, setOpen] = useState(false);

    return (
        <div
            className="nav-item dropdown nav-dropdown"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            {path ? (
                <NavLink
                    to={path}
                    className="nav-link dropdown-toggle"
                    aria-expanded={open ? "true" : "false"}
                >
                    {label}
                </NavLink>
            ) : (
                <span
                    className="nav-link dropdown-toggle cursor-default"
                    onClick={(e) => e.preventDefault()}
                    aria-expanded={open ? "true" : "false"}
                >
                    {label}
                </span>
            )}

            <div className={`dropdown-menu ${open ? "show" : ""}`}>
                {children}
            </div>
        </div>
    );
}

export default NavDropdown;
